import { Restore as RestoreIcon } from "@mui/icons-material";
import { MenuItemWithIcon, ModalOpenButton } from "@msys/ui";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { TemplatesQuoteTemplateManageVersionsModal } from "../TemplatesQuoteTemplateManageVersionsModal.js";

interface Props {
  docId: string;
  pathToDoc: string;
  refetchQueries?: string[];
  title?: string;
}

export const QuoteTemplateManageVersionsMenuItem = React.forwardRef<
  HTMLLIElement,
  Props
>(({ title, docId, pathToDoc, refetchQueries }, ref) => {
  const { t } = useTranslate("TemplatesSharing");

  return (
    <ModalOpenButton
      Modal={TemplatesQuoteTemplateManageVersionsModal}
      modalProps={{
        docId,
        pathToDoc,
        refetchQueries,
      }}
    >
      <MenuItemWithIcon ref={ref} icon={<RestoreIcon />}>
        {title ?? t("Manage versions")}
      </MenuItemWithIcon>
    </ModalOpenButton>
  );
});
